<template>
  <div class="app">
    <div class="content">
      <div class="content-boxs" v-for="(item,index) in list" :key="index" @click="goPage(item)">
        <img :src="item.icon" class="grid-img" />
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  data() {
    return {
      list:[
        {
          title:"共产党员",
          path:"https://www.12371.cn/",
          icon:require("@images/zhdj/gcdy-bg.png")
        },
        {
          title:"人民日报",
          path:"http://paper.people.com.cn/",
          icon:require("@images/zhdj/rmrb-bg.png")
        },
        {
          title:"党建研究",
          path:"https://djyj.12371.cn/",
          icon:require("@images/zhdj/djyj-bg.png")
        },
        {
          title:"陕西党建",
          path:"http://www.sx-dj.gov.cn/",
          icon:require("@images/zhdj/sxdj-bg.png")
        },
      ]
    }
  },
  created() {
   
  },
  mounted() {
  },
  methods: {
    goPage(item){
      window.location.href = item.path;
    }
  },
}
</script>

<style lang="less" scoped>
.app{
  width: 100%;
  height: 100vh;
  background: #f6f7f9;
}
.content{
  width: 100%;
  padding: 10px 12px;
  box-sizing: border-box;
  &-boxs{
    width: 100%;
    box-sizing: border-box;
    margin: 16px 0px;
    img{
      width: 100%;
    }
  }
}
</style>
